import { __awaiter } from '../_virtual/_tslib.js';
import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import { CACHE_NAME } from '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'bowser';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import './getAuthIdParam.js';
import 'react';
import 'react-cookie';
import './formatDate.js';
import '../constants/StateList.js';
import './getTransporterFigure.js';
import './getDownloadsFigure.js';
import 'lodash.isequal';
import './getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../constants/serviceTypeId.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';

function addToCache(request, res) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const cache = yield ((_a = window.caches) === null || _a === void 0 ? void 0 : _a.open(CACHE_NAME));
            const clonedRes = res === null || res === void 0 ? void 0 : res.clone();
            const headers = new Headers(clonedRes === null || clonedRes === void 0 ? void 0 : clonedRes.headers);
            headers.append("sw-fetched-on", new Date().getTime().toString());
            const body = yield clonedRes.blob();
            yield (cache === null || cache === void 0 ? void 0 : cache.put(request, new Response(body, { status: clonedRes.status, statusText: clonedRes.statusText, headers })));
        }
        catch (_b) {
            // Safari private mode / invalid cache keys — skip caching, keep API working.
        }
    });
}

export { addToCache };
//# sourceMappingURL=addToCache.js.map
